module.exports = __webpack_public_path__ + "img/acuerdoCapte01.6ac88d1b.jpg";